/**
 * @generated SignedSource<<66215e74cad06e67db0eeb783ae5fee2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BoardContainerQuery$variables = {
  boardId: string;
};
export type BoardContainerQuery$data = {
  readonly board: {
    readonly historiesByBoardId: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly author: {
            readonly name: string | null;
          } | null;
          readonly createdAt: string;
          readonly id: string;
          readonly status: string | null;
        } | null;
      }>;
    };
    readonly rowId: string;
    readonly " $fragmentSpreads": FragmentRefs<"Board_board">;
  } | null;
};
export type BoardContainerQuery = {
  response: BoardContainerQuery$data;
  variables: BoardContainerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "rowId",
    "variableName": "boardId"
  }
],
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "boardId",
        "variableName": "boardId"
      }
    ],
    "kind": "ObjectValue",
    "name": "condition"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 2
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "CREATED_AT_DESC"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v11 = [
  (v6/*: any*/),
  (v3/*: any*/)
],
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "ORDER_ASC"
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "order",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "guid",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstname",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastname",
    "storageKey": null
  },
  (v3/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authorByUpdatedBy",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authorByCreatedBy",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BoardContainerQuery",
    "selections": [
      {
        "alias": "board",
        "args": (v1/*: any*/),
        "concreteType": "Board",
        "kind": "LinkedField",
        "name": "boardByRowId",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Board_board"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "HistoriesConnection",
            "kind": "LinkedField",
            "name": "historiesByBoardId",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "HistoriesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": "author",
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authorByAccomplishedBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoardContainerQuery",
    "selections": [
      {
        "alias": "board",
        "args": (v1/*: any*/),
        "concreteType": "Board",
        "kind": "LinkedField",
        "name": "boardByRowId",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rssFeed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rdfFeed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ModuleImage",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "altText",
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "copyright",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seoTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasIntroductionText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "introductionHeadline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "introductionText",
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Category",
            "kind": "LinkedField",
            "name": "categoryByCategoryId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SocialMediaAccount",
            "kind": "LinkedField",
            "name": "socialMediaAccounts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "service",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "label",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "accountName",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noindex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "HistoriesConnection",
            "kind": "LinkedField",
            "name": "historiesByBoardId",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HistoriesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "data",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authorByAccomplishedBy",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": "author",
                        "args": null,
                        "concreteType": "Author",
                        "kind": "LinkedField",
                        "name": "authorByAccomplishedBy",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "BoardsSectionsConnection",
            "kind": "LinkedField",
            "name": "boardsSectionsByBoardId",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BoardsSectionsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BoardsSection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "boardLink",
                        "storageKey": null
                      },
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "schema",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Category",
                        "kind": "LinkedField",
                        "name": "categoryByCategoryId",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v12/*: any*/),
                        "concreteType": "BoardsSectionsItemsConnection",
                        "kind": "LinkedField",
                        "name": "boardsSectionsItemsByBoardsSectionId",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "BoardsSectionsItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "BoardsSectionsItem",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "articleId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "boardsTeaserId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "boardId",
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "boardsSectionsItemsByBoardsSectionId(first:1000,orderBy:\"ORDER_ASC\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "autofill",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "meta",
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showHeroTitleForMobile",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "boardsSectionsByBoardId(first:1000,orderBy:\"ORDER_ASC\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "protected",
            "storageKey": null
          },
          (v5/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Author",
            "kind": "LinkedField",
            "name": "authorByLockedBy",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lockedSince",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6bd960d3e4d00d015aff1b0a61aa5d1d",
    "id": null,
    "metadata": {},
    "name": "BoardContainerQuery",
    "operationKind": "query",
    "text": "query BoardContainerQuery(\n  $boardId: String!\n) {\n  board: boardByRowId(rowId: $boardId) {\n    ...Board_board\n    historiesByBoardId(first: 2, condition: {boardId: $boardId}, orderBy: CREATED_AT_DESC) {\n      edges {\n        node {\n          id\n          createdAt\n          status\n          author: authorByAccomplishedBy {\n            name\n            id\n          }\n        }\n      }\n    }\n    rowId\n    id\n  }\n}\n\nfragment Board_board on Board {\n  rowId\n  rssFeed\n  rdfFeed\n  parentId\n  image {\n    url\n    altText\n    title\n    copyright\n    id\n  }\n  slug\n  title\n  seoTitle\n  description\n  hasIntroductionText\n  introductionHeadline\n  introductionText\n  categoryId\n  categoryByCategoryId {\n    rowId\n    id\n  }\n  socialMediaAccounts {\n    service\n    label\n    accountName\n  }\n  noindex\n  historiesByBoardId(first: 2, condition: {boardId: $boardId}, orderBy: CREATED_AT_DESC) {\n    totalCount\n    edges {\n      node {\n        createdAt\n        rowId\n        data\n        authorByAccomplishedBy {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  boardsSectionsByBoardId(first: 1000, orderBy: ORDER_ASC) {\n    totalCount\n    edges {\n      node {\n        boardLink\n        rowId\n        schema\n        categoryId\n        categoryByCategoryId {\n          rowId\n          title\n          id\n        }\n        title\n        color\n        boardsSectionsItemsByBoardsSectionId(first: 1000, orderBy: ORDER_ASC) {\n          totalCount\n          edges {\n            node {\n              rowId\n              articleId\n              boardsTeaserId\n              boardId\n              order\n              id\n            }\n          }\n        }\n        autofill\n        meta\n        order\n        showHeroTitleForMobile\n        updatedBy\n        authorByUpdatedBy {\n          guid\n          firstname\n          lastname\n          id\n        }\n        updatedAt\n        createdBy\n        authorByCreatedBy {\n          guid\n          firstname\n          lastname\n          id\n        }\n        createdAt\n        id\n      }\n    }\n  }\n  protected\n  status\n  updatedBy\n  authorByUpdatedBy {\n    guid\n    firstname\n    lastname\n    id\n  }\n  updatedAt\n  createdBy\n  authorByCreatedBy {\n    guid\n    firstname\n    lastname\n    id\n  }\n  createdAt\n  authorByLockedBy {\n    guid\n    firstname\n    lastname\n    id\n  }\n  lockedBy\n  lockedSince\n  ...LockHandling_board\n}\n\nfragment LockHandling_board on Board {\n  rowId\n  lockedBy\n  lockedSince\n  authorByLockedBy {\n    guid\n    firstname\n    lastname\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "eb2ac3e844c0406542ee34cd2916c607";

export default node;
